/* src/routes/projects/index.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostLink from "../../../_components/Post-Link.svelte.js";
import OpenInGithub from "../../../_components/Open-In-Github.svelte.js";

function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Easy to use Memoize/Caching attribute implemented in C#");
		},
		l(nodes) {
			t = claim_text(nodes, "Easy to use Memoize/Caching attribute implemented in C#");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (12:0) <PostLink title="p5-typescript-starter" slug="/projects/p5-typescript-starter" tags="p5js,starter-project,typescript">
function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text("Base starter project using p5js and typescript");
		},
		l(nodes) {
			t = claim_text(nodes, "Base starter project using p5js and typescript");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let postlink0;
	let t;
	let postlink1;
	let current;

	postlink0 = new PostLink({
			props: {
				title: "Memoizer",
				slug: "/projects/Memoizer",
				tags: "nuget",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	postlink1 = new PostLink({
			props: {
				title: "p5-typescript-starter",
				slug: "/projects/p5-typescript-starter",
				tags: "p5js,starter-project,typescript",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postlink0.$$.fragment);
			t = space();
			create_component(postlink1.$$.fragment);
		},
		l(nodes) {
			claim_component(postlink0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postlink1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postlink0, target, anchor);
			insert(target, t, anchor);
			mount_component(postlink1, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postlink0_changes = {};

			if (dirty & /*$$scope*/ 1) {
				postlink0_changes.$$scope = { dirty, ctx };
			}

			postlink0.$set(postlink0_changes);
			const postlink1_changes = {};

			if (dirty & /*$$scope*/ 1) {
				postlink1_changes.$$scope = { dirty, ctx };
			}

			postlink1.$set(postlink1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postlink0.$$.fragment, local);
			transition_in(postlink1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postlink0.$$.fragment, local);
			transition_out(postlink1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postlink0, detaching);
			if (detaching) detach(t);
			destroy_component(postlink1, detaching);
		}
	};
}

class Projects extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Projects;
//# sourceMappingURL=index.svelte.js.map
